import React, { useState } from "react";
import { Button } from 'antd';
import { PlusOutlined } from "@ant-design/icons";

import { GET_STANDS_CURSOR } from "graphql/query/stand-gql";

import Stands from "components/stands";
import GraphicStorage from "components/graphic-storage";
import Craft from "components/craft";
import { Tables, TotalItems } from "components/layout";
import { ModalStandard, Localize } from "components/service";
import { useBreadCrumbs } from "components/use-hooks";
import { gqlBuilderWhere } from 'utils';


const basePath = GraphicStorage.Const.basePath;
const tableHelper = Stands.Helpers.TableGraphic;


const GraphicStorageGraphicsSubPage = ({ graphicStorage }) => {

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Exhibitions" }).props.children,
            path: `${ basePath }`
        },
        {
            label: graphicStorage?.title,
            path: `${ basePath }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_GraphicStorage" }).props.children,
            path: `${ basePath }/${ graphicStorage?.id }/graphics`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    const routeUrl = `${ basePath }/${ graphicStorage?.id }/graphics`;

    const objOrderBy = [
        {
            relCrafts: {
                aggregate: 'MAX',
                column: 'CREATED_AT'
            }, order: 'DESC'
        }
    ];

    const filterTable = 'table-graphic-storage-graphics';

    const standsFilters = JSON.parse(localStorage.getItem(`standsFilters-${ filterTable }_eeID-${ graphicStorage?.id }`));
    const standsSorting = JSON.parse(localStorage.getItem(`standsSorting-${ filterTable }_eeID-${ graphicStorage?.id }`));
    const standsSearch = JSON.parse(localStorage.getItem(`standsSearch-${ filterTable }_eeID-${ graphicStorage?.id }`));

    const [ searchText, setSearchText ] = useState(standsSearch);
    const [ filters, setFilters ] = useState(gqlBuilderWhere(standsFilters));
    const [ resetSorting, setResetSorting ] = useState(false);


    return (
        <Tables.Cursor
            extraClass="table-graphic-storage-graphics"
            tableLayout=""
            model="standsCursor"
            query={ GET_STANDS_CURSOR }
            varSet={ {
                exclude_graphics_sent: true,
                perPage: 30,
                ee_id: +graphicStorage?.id,
                whereCrafts: {
                    column: 'TYPE',
                    value: "collect_graphics"
                }
            } }
            routeUrl={ routeUrl }
            searchText={ searchText }
            objFilter={ filters }
            objOrderBy={ standsSorting || objOrderBy }
            sortingName={ `standsSorting-${ filterTable }_eeID-${ graphicStorage?.id }` }
            tableHelper={ tableHelper }
            resetSorting={ resetSorting }
        >
            { ({ pageInfo, model }) => (
                <>
                    <div className="table-action-bar">

                        <div className="col">
                            <Stands.Filters.Table
                                event={ graphicStorage }
                                setSearchText={ setSearchText }
                                setFilters={ setFilters }
                                filters={ filters }
                                standsFilters={ standsFilters }
                                searchText={ searchText }
                                setResetSorting={ setResetSorting }
                                objOrderBy={ objOrderBy }
                                excludeFields={ [ 'AQUISE_NUMBER', 'CAD_NUMBER', 'DELIVERY_TIME_AT', 'HALL_ID' ] }
                                filterTable={ filterTable }
                            />
                            <TotalItems
                                pageInfo={ pageInfo }
                            />
                        </div>

                        <div className="col">
                            <ModalStandard
                                width={ 520 }
                                extraClass={ 'modal-form' }
                                modalButton={
                                    <Button
                                        type="primary">
                                        <PlusOutlined /> <Localize>MODAL.Button_Text_AddPrint</Localize>
                                    </Button>
                                }>
                                <strong className="modal-title"><Localize>FORMS.Title_AddPrint</Localize></strong>
                                <Craft.Forms.AddPrint
                                    propsObj={ {
                                        query: GET_STANDS_CURSOR,
                                        event: graphicStorage
                                    } } />
                            </ModalStandard>
                        </div>
                    </div>
                </>
            ) }
        </Tables.Cursor>
    );
};

export default GraphicStorageGraphicsSubPage;
